import React , {useState, useEffect, useLayoutEffect, useMemo, useCallback, useRef} from 'react';
import { useLocation } from "@reach/router"

import Header from './../../container/Header/Header.js';
import Footer from './../../container/Footer/Footer.js';
import ReturnLink from './../../components/ReturnLink/ReturnLink.js';
import {Container, Row, Col, Button, Badge} from 'react-bootstrap';
import Input from './../../components/Input/Input.js';
import {ReactComponent as Times} from '../../assets/image/times.svg';
import {ReactComponent as PlusIcon} from '../../assets/image/plus.svg';
import CardEvent from '../../components/CardEvent/CardEvent.js'
import KeywordSearchBar from '../../components/KeywordSearchBar/KeywordSearchBar.js';
import {Helmet} from "react-helmet";
import axios from "axios";
import variables from "./../../variables.js";
import { buildGeoParamsForLookups } from '../../utils/buildGeoParamsForLookups.js';

import './Programmation.scss'

export const useQuery = queryParam => {
    const search = new URLSearchParams(useLocation().search);
    const param = search.get(queryParam);
    let finalResult = param;
    try {
        const parsedParam = JSON.parse(param);
        if (Array.isArray(parsedParam)) {
            finalResult = parsedParam.map(item => ({value: item, label: item}));
        } else {
            finalResult = parsedParam;
        }
    } catch (e) {
        if (param && typeof param === 'string' && param.includes(',')) {
            finalResult = param.split(',').map(item => ({value: item, label: item}));
        } else if (param) {
            finalResult = [{value: param, label: param}];
        } else {
            finalResult = param;
        }
    }
    return finalResult;
};

function mergeFilterOption(current, option) {
    const arr = Array.isArray(current) ? current : [];
    if (arr.some((x) => String(x.value) === String(option.value))) return arr;
    return [...arr, option];
}

function normalizeKeywordList(applied) {
    if (applied == null || applied === '') return [];
    if (Array.isArray(applied)) {
        return applied.map((k) => String(k).trim()).filter((k) => k.length > 0);
    }
    return [String(applied).trim()].filter((k) => k.length > 0);
}

function readKeywordsFromUrlSearchParams(params) {
    if (!params || typeof params.get !== 'function') return [];
    const all = typeof params.getAll === 'function' ? params.getAll('keyword') : [];
    const fromRepeated = all.map((k) => String(k).trim()).filter((k) => k.length > 0);
    if (fromRepeated.length > 0) return fromRepeated;
    const single = params.get('keyword');
    if (!single) return [];
    return [String(single).trim()].filter((k) => k.length > 0);
}

function serializeEventsSearchParams(params) {
    const p = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const val = params[key];
        if (val === undefined || val === null || val === '') return;
        if (Array.isArray(val)) {
            val.forEach((item) => {
                if (item !== undefined && item !== null && String(item) !== '') {
                    p.append(key, String(item));
                }
            });
        } else {
            p.append(key, String(val));
        }
    });
    return p.toString();
}

const Programmation = () => {
    const [results,changeResults] = useState(false);
    const [resultsNumber,changeResultsNumber] = useState(0);
    const [loadMoreLock,changeLoadMoreLock] = useState(false);
    const [searchRegion,changeSearchRegion] = useState(false);
    const [searchVille,changeSearchVille] = useState(false);
    const [searchActivites,changeSearchActivites] = useState(false);
    const [searchArtistes,changeSearchArtistes] = useState(false);
    const [choicesRegion,changeChoicesRegion] = useState(false);
    const [choicesVille,changeChoicesVille] = useState([]);
    const [choicesActivites,changeChoicesActivites] = useState(false);
    const [choicesArtistes,changeChoicesArtistes] = useState(false);
    const [date23,changeDate23] = useState(false);
    const [date24,changeDate24] = useState(false);
    const [userLat,changeUserLat] = useState(false);
    const [userLng,changeUserLng] = useState(false);
    const [defaultsChecked,changeDefaultsChecked] = useState(false);
    const [allChoicesLoaded, setAllChoicesLoaded] = useState(false);
    const [choicesRegionLoaded, setChoicesRegionLoaded] = useState(false);
    const [choicesVilleLoaded, setChoicesVilleLoaded] = useState(false);
    const [choicesLookupsLoaded, setChoicesLookupsLoaded] = useState(false);
    const geoLookupsRequestGen = useRef(0);
    const [keywordDraft, setKeywordDraft] = useState('');
    const [keywordApplied, setKeywordApplied] = useState([]);
    const [showMoreFilters, setShowMoreFilters] = useState(false);
    const keywordBlockRef = useRef(null);
    console.log("Programmation: defaultsChecked initial state", defaultsChecked);

    useLayoutEffect(() => {
        const el = keywordBlockRef.current;
        if (!el) return;
        if (showMoreFilters) {
            const hadFocusInside = typeof document !== 'undefined' && el.contains(document.activeElement);
            el.setAttribute('inert', '');
            el.setAttribute('aria-hidden', 'true');
            if (hadFocusInside) {
                const stack = el.parentElement;
                const closeBtn = stack?.querySelector('.searchForm__advancedPanelClose');
                queueMicrotask(() => closeBtn?.focus());
            }
        } else {
            el.removeAttribute('inert');
            el.removeAttribute('aria-hidden');
        }
    }, [showMoreFilters]);
    const urlSelectedActivites = useQuery("activites");
    const urlSelectedArtistes = useQuery("artistes");
    const location = useLocation();
    const { pathname, search } = location;
    const urlParams = search;
    // const [limit,changeLimit] = useState(false);
    const urlSelectedRegion = useQuery("region");
    const urlSelectedCity = useQuery("ville");
    const urlLimit = useQuery("limit");
    // let urlDefaults = new URLSearchParams(urlParams);

     // Memoized filtered choicesVille based on selected region(s)
    const filteredChoicesVille = useMemo(() => {
    
        if (!Array.isArray(searchRegion) || searchRegion.length === 0) {
            return choicesVille; // Return all cities if no region is selected
        }
    
        const selectedRegionIds = searchRegion.map(region => region.value); 
        //console.log('Debug: Selected Region IDs:', selectedRegionIds);
    
        const filtered = choicesVille.filter(city => {
            return selectedRegionIds.includes(city.region); 
        });    
        return filtered;
    }, [choicesVille, searchRegion]);

    const keywordSuggestions = useMemo(() => {
        const q = keywordDraft.trim().toLowerCase();
        if (!q) return [];
        const out = [];
        const pushMatches = (source, list, mapRow) => {
            if (!Array.isArray(list)) return;
            list.forEach((item) => {
                if (String(item.label).toLowerCase().includes(q)) {
                    out.push(mapRow(item));
                }
            });
        };
        pushMatches('region', choicesRegion, (item) => ({ source: 'region', value: item.value, label: item.label }));
        pushMatches('ville', filteredChoicesVille, (item) => ({ source: 'ville', value: item.value, label: item.label, region: item.region }));
        pushMatches('activite', choicesActivites, (item) => ({ source: 'activite', value: item.value, label: item.label }));
        pushMatches('artiste', choicesArtistes, (item) => ({ source: 'artiste', value: item.value, label: item.label }));
        return out.slice(0, 25);
    }, [keywordDraft, choicesRegion, filteredChoicesVille, choicesActivites, choicesArtistes]);
    
    // Effect to remove selected villes outside the selected region(s)
    useEffect(() => {

    
        if (Array.isArray(searchVille) && searchVille.length > 0 && Array.isArray(searchRegion) && searchRegion.length > 0) {
            const selectedRegionIds = searchRegion.map(region => region.value);
    
            const filteredSearchVille = searchVille.filter(ville => {
                // If ville doesn't have region property or region is null, keep it (likely from URL)
                if (!ville.region || ville.region === null) {
                    return true;
                }
                return selectedRegionIds.includes(ville.region);
            });    
            
            let hasChanges = false;

            for (let i = 0; i < searchVille.length; i++) {
                const ville = searchVille[i];
                // Skip filtering if ville doesn't have region property (likely from URL)
                if (ville.region && !selectedRegionIds.includes(ville.region)) {
                    hasChanges = true;
                    break;
                }
            }

            if (hasChanges) {
                changeSearchVille(filteredSearchVille);
            }
            
        }
    }, [searchRegion, searchVille]);

    // Effect to update labels once choice data is loaded
    useEffect(() => {
        // Update ville labels
        if (Array.isArray(searchVille) && searchVille.length > 0 && Array.isArray(choicesVille) && choicesVille.length > 0) {
            const updatedVilles = searchVille.map(ville => {
                const choice = choicesVille.find(choice => choice.value === ville.value);
                return choice ? { ...ville, label: choice.label, region: choice.region } : ville;
            });
            
            // Check if any labels need updating
            const needsUpdate = updatedVilles.some((ville, index) => 
                ville.label !== searchVille[index].label || ville.region !== searchVille[index].region
            );
            
            if (needsUpdate) {
                changeSearchVille(updatedVilles);
            }
        }

        // Update region labels
        if (Array.isArray(searchRegion) && searchRegion.length > 0 && Array.isArray(choicesRegion) && choicesRegion.length > 0) {
            const updatedRegions = searchRegion.map(region => {
                const choice = choicesRegion.find(choice => choice.value === region.value);
                return choice ? { ...region, label: choice.label } : region;
            });
            
            // Check if any labels need updating
            const needsUpdate = updatedRegions.some((region, index) => 
                region.label !== searchRegion[index].label
            );
            
            if (needsUpdate) {
                changeSearchRegion(updatedRegions);
            }
        }

        // Update activites labels
        if (Array.isArray(searchActivites) && searchActivites.length > 0 && Array.isArray(choicesActivites) && choicesActivites.length > 0) {
            const updatedActivites = searchActivites.map(activite => {
                const choice = choicesActivites.find(choice => choice.value === activite.value);
                return choice ? { ...activite, label: choice.label } : activite;
            });
            
            // Check if any labels need updating
            const needsUpdate = updatedActivites.some((activite, index) => 
                activite.label !== searchActivites[index].label
            );
            
            if (needsUpdate) {
                changeSearchActivites(updatedActivites);
            }
        }

        // Update artistes labels
        if (Array.isArray(searchArtistes) && searchArtistes.length > 0 && Array.isArray(choicesArtistes) && choicesArtistes.length > 0) {
            const updatedArtistes = searchArtistes.map(artiste => {
                const choice = choicesArtistes.find(choice => choice.value === artiste.value);
                return choice ? { ...artiste, label: choice.label } : artiste;
            });
            
            // Check if any labels need updating
            const needsUpdate = updatedArtistes.some((artiste, index) => 
                artiste.label !== searchArtistes[index].label
            );
            
            if (needsUpdate) {
                changeSearchArtistes(updatedArtistes);
            }
        }
    }, [choicesVille, choicesRegion, choicesActivites, choicesArtistes, searchVille, searchRegion, searchActivites, searchArtistes]);

    //console.log(urlParams);

    const removeSearch = (id,type) => {
        var work_array = [];
        var export_array = [];
        //read
        if (type === 'keyword') {
            setKeywordDraft('');
            if (id == null || id === '') {
                setKeywordApplied([]);
            } else {
                setKeywordApplied((prev) => normalizeKeywordList(prev).filter((k) => k !== id));
            }
            resetPage();
            return;
        }
        switch(type){
            case 'region':
                work_array = searchRegion;
            break;
            case 'ville':
                work_array = searchVille;
            break;
            case 'artistes':
                work_array = searchArtistes;
            break;
            case 'activites':
                work_array = searchActivites;
            break;
            default:
            break;
        }
        //change
        export_array = work_array.filter((w)=> w.value !== id);
        //console.log(id);
        //console.log(type);
        //console.log(work_array);
        //write
        switch(type){
            case 'region':
                changeSearchRegion(export_array);
            break;
            case 'ville':
                changeSearchVille(export_array);
            break;
            case 'artistes':
                changeSearchArtistes(export_array);
            break;
            case 'activites':
                changeSearchActivites(export_array);                
            break;
            default:
            break;
        }
        resetPage();
    }

    const loadMoreResults = useCallback((onload) => {
        /* URL Search */
        const {
            pathname, search
        } = window.location

        let queryString = '?search=1'
        if(searchRegion && searchRegion.length > 0){
            const regionValues = searchRegion.map(item => item.value);
            queryString+='&regions='+regionValues.join(',');
        }
        if(searchVille && searchVille.length > 0){
            const villeValues = searchVille.map(item => item.value);
            queryString+='&ville='+villeValues.join(',');
        }
        if(searchActivites && searchActivites.length > 0){
            const activitesValues = searchActivites.map(item => item.value);
            queryString+='&activites='+activitesValues.join(',');
        }
        if(searchArtistes && searchArtistes.length > 0){
            const artistesValues = searchArtistes.map(item => item.value);
            queryString+='&artistes='+artistesValues.join(',');
        }
        if(date23){
            queryString+='&date23='+date23;
        }
        if(date24){
            queryString+='&date24='+date24;
        }
        const kws = normalizeKeywordList(keywordApplied);
        kws.forEach((k) => {
            queryString += '&keyword=' + encodeURIComponent(k);
        });
        /* end URL Search*/
        if(!loadMoreLock){
            changeLoadMoreLock(true);
            var searchParams = {
                offset:Array.isArray(results) ? results.length : 0,
                limit: onload && urlLimit ? urlLimit : 12,
            }
            if(date23 && !date24){
                searchParams.date_event = '23';
            }else if(!date23 && date24){
                searchParams.date_event = '24';
            }
            if (Array.isArray(searchRegion) && searchRegion.length > 0) {
                const regionIds = searchRegion
                    .filter(region => region.value !== 'all')
                    .map(region => region.value);
                if (regionIds.length > 0) {
                    searchParams.region = regionIds.join(',');
                }
            }
            if (Array.isArray(searchVille) && searchVille.length > 0) {
                const cityIds = searchVille
                    .filter(region => region.value !== 'all')
                    .map(region => region.value);
                if (cityIds.length > 0) {
                    searchParams.cities_id = cityIds.join(',');
                }
            }
            if (Array.isArray(searchArtistes) && searchArtistes.length > 0) {
                const artistIds = searchArtistes
                    .filter(region => region.value !== 'all')
                    .map(region => region.value);
                if (artistIds.length > 0) {
                    searchParams.artists_id = artistIds.join(',');
                }
            }
            if (Array.isArray(searchActivites) && searchActivites.length > 0) {
                const eventTypeIds = searchActivites
                    .filter(region => region.value !== 'all')
                    .map(region => region.value);
                if (eventTypeIds.length > 0) {
                    searchParams.eventstypes_id = eventTypeIds.join(',');
                }
            }
            if (kws.length === 1) {
                searchParams.keyword = kws[0];
            } else if (kws.length > 1) {
                searchParams.keyword = kws;
            }
            //console.log(variables.site+'/events/');
            axios({
                method:'get',
                url:variables.site+'/events',
                params:searchParams,
                paramsSerializer: serializeEventsSearchParams
                //headers:pixheaders
            }).then(function(response){
                window.localStorage.setItem('loadedresults',0);
                //console.log(response);
                //console.log(searchParams)
                if(response.status === 200){
                    //console.log(response.data.data);
                    //console.log(results);
                    if(Array.isArray(results)){
                        let newResults = [...results,...response.data.data];
                        changeResults(
                            //results.cocat(response.data.data)
                            newResults
                        );
                        window.localStorage.setItem('loadedresults',newResults.length);
                    }else{
                        changeResults(response.data.data);
                        window.localStorage.setItem('loadedresults',response.data.data.length);
                    }
                    
                    if (onload) {
                        const scrollPos = window.localStorage.getItem('LastScrollPos');
                        if (scrollPos > 0) {
                            setTimeout(() => window.scrollTo(0, scrollPos), 100);
                            window.localStorage.setItem('LastScrollPos',0);
                        }
                    }
                    queryString += '&limit='+window.localStorage.getItem('loadedresults');
                    
                    if(search !== queryString){
                        console.log('pushState: ', queryString);
                        console.log('pushState: ', pathname+queryString);
                        window.history.pushState({},"",pathname+queryString);
                    }
        
                    window.localStorage.setItem('currentsearch',pathname+queryString+'&limit='+window.localStorage.getItem('loadedresults'));
                    changeResultsNumber(response.data.total);
                }
                changeLoadMoreLock(false);
            })
        }
    }, [date23, date24, keywordApplied, loadMoreLock, results, searchActivites, searchArtistes, searchRegion, searchVille, urlLimit]);

    useEffect(() => {
        if (!searchRegion && !searchVille && !searchActivites && !searchArtistes && !defaultsChecked) {
            changeDefaultsChecked(true);
            const urlDefaults = new URLSearchParams(urlParams);
            if (urlDefaults.get('regions')) {
                const regionValues = urlDefaults.get('regions').split(',').map((value) => ({ value: value, label: value }));
                changeSearchRegion(regionValues);
            }
            if (urlDefaults.get('ville')) {
                const villeValues = urlDefaults.get('ville').split(',').map((value) => {
                    const villeChoice = choicesVille.find((choice) => choice.value === value);
                    return villeChoice ? villeChoice : { value: value, label: value, region: null };
                });
                changeSearchVille(villeValues);
            }
            if (urlDefaults.get('activites')) {
                const activitesValues = urlDefaults.get('activites').split(',').map((value) => ({ value: value, label: value }));
                changeSearchActivites(activitesValues);
            }
            if (urlDefaults.get('artistes')) {
                const artistesValues = urlDefaults.get('artistes').split(',').map((value) => ({ value: value, label: value }));
                changeSearchArtistes(artistesValues);
            }
            if (urlDefaults.get('date23')) {
                changeDate23(true);
            }
            if (urlDefaults.get('date24')) {
                changeDate24(true);
            }
            const urlKeywords = readKeywordsFromUrlSearchParams(urlDefaults);
            if (urlKeywords.length > 0) {
                setKeywordApplied(urlKeywords);
            }
        }
        if (!results && defaultsChecked) {
            loadMoreResults(true);
        }
    }, [results, defaultsChecked, searchActivites, searchArtistes, searchRegion, searchVille, urlParams, choicesVille, loadMoreResults]);

    // New useEffect for URL synchronization
    useEffect(() => {
        console.log("URL Sync Effect: defaultsChecked at start", defaultsChecked);
        // Ignore new params on load until initial defaults are checked.
        if (!defaultsChecked) {
            return;
        }
        
        // const { pathname: currentPathname, search: currentSearch } = window.location; // Destructure outside for stable reference
        let queryString = '?search=1';

        if(searchRegion && searchRegion.length > 0){
            const regionValues = searchRegion.map(item => item.value);
            queryString+='&regions='+ (regionValues.length === 1 ? regionValues[0] : encodeURIComponent(regionValues.join(',')));
        }
        if(searchVille && searchVille.length > 0){
            const villeValues = searchVille.map(item => item.value);
            queryString+='&ville='+ (villeValues.length === 1 ? villeValues[0] : encodeURIComponent(villeValues.join(',')));
        }
        if(searchActivites && searchActivites.length > 0){
           const activitesValues = searchActivites.map(item => item.value);
           queryString+='&activites='+ (activitesValues.length === 1 ? activitesValues[0] : encodeURIComponent(activitesValues.join(',')));
        }
        if(searchArtistes && searchArtistes.length > 0){
            const artistesValues = searchArtistes.map(item => item.value);
            queryString+='&artistes='+ (artistesValues.length === 1 ? artistesValues[0] : encodeURIComponent(artistesValues.join(',')));
        }
        if(date23){
            queryString+='&date23='+date23;
        }
        if(date24){
            queryString+='&date24='+date24;
        }
        normalizeKeywordList(keywordApplied).forEach((k) => {
            queryString += '&keyword=' + encodeURIComponent(k);
        });

        // Compare parsed URLSearchParams to avoid redirection due to parameter order
        const currentParams = new URLSearchParams(search);
        const newParams = new URLSearchParams(queryString);

        if (currentParams.toString() !== newParams.toString()) { // Only update if params truly changed
            window.history.pushState({},"",pathname+queryString);
            window.localStorage.setItem('currentsearch',pathname+queryString);
        }
    }, [searchRegion, searchVille, searchActivites, searchArtistes, date23, date24, keywordApplied, pathname, search, defaultsChecked]); // Added defaultsChecked to dependencies
    
    // Effect to remove selected villes outside the selected region(s)
    useEffect(() => {
    
        if (Array.isArray(searchVille) && searchVille.length > 0 && Array.isArray(searchRegion) && searchRegion.length > 0) {
            const selectedRegionIds = searchRegion.map(region => region.value);
    
            const filteredSearchVille = searchVille.filter(ville => {
                // If ville doesn't have region property or region is null, keep it (likely from URL)
                if (!ville.region || ville.region === null) {
                    return true;
                }
                return selectedRegionIds.includes(ville.region);
            });    
            
            let hasChanges = false;

            for (let i = 0; i < searchVille.length; i++) {
                const ville = searchVille[i];
                // Skip filtering if ville doesn't have region property (likely from URL)
                if (ville.region && !selectedRegionIds.includes(ville.region)) {
                    hasChanges = true;
                    break;
                }
            }

            if (hasChanges) {
                changeSearchVille(filteredSearchVille);
            }
            
        }
    }, [searchRegion, searchVille]);

    useEffect(()=>{
        // This useEffect is responsible for initial filter preselection from URL and setting defaultsChecked
        if(!allChoicesLoaded || defaultsChecked) return; // Only run if all choices are loaded and defaults haven't been checked yet

        let urlDefaults = new URLSearchParams(urlParams); // Define urlDefaults inside the effect

        console.log("Main Preselection Effect: allChoicesLoaded is", allChoicesLoaded, "defaultsChecked is", defaultsChecked);

        // Preselect regions
        if(urlSelectedRegion && urlSelectedRegion.length > 0){
            changeSearchRegion(urlSelectedRegion);
        }
        // Preselect cities
        if(urlSelectedCity && urlSelectedCity.length > 0){
            changeSearchVille(urlSelectedCity);
        }
        // Preselect activites
        if(urlSelectedActivites && Array.isArray(urlSelectedActivites) && urlSelectedActivites.length > 0){
            console.log("Main Preselection Effect: Preselecting activites:", urlSelectedActivites);
            changeSearchActivites(urlSelectedActivites);
        }
        // Preselect artistes
        if(urlSelectedArtistes && urlSelectedArtistes.length > 0){
            changeSearchArtistes(urlSelectedArtistes);
        }
        // Preselect date23 and date24 (still relying on urlDefaults as they don't use useQuery)
        if(urlDefaults.get('date23')){
            changeDate23(true);
        }
        if(urlDefaults.get('date24')){
            changeDate24(true);
        }
        const preKws = readKeywordsFromUrlSearchParams(urlDefaults);
        if (preKws.length > 0) {
            setKeywordApplied(preKws);
        }
        
        // Mark defaults as checked after attempting all preselection
        changeDefaultsChecked(true);
    },[allChoicesLoaded, urlSelectedRegion, urlSelectedCity, urlSelectedArtistes, urlSelectedActivites, defaultsChecked, searchRegion, searchVille, searchArtistes, searchActivites, urlParams, date23, date24, choicesActivites]) // Added choicesActivites to dependency array
    
    useEffect(() => {
        console.log("Programmation: defaultsChecked changed to", defaultsChecked);
    }, [defaultsChecked]);

    // Fetch Regions
    useEffect(() => {
        if (!choicesRegionLoaded) {
            axios({
                method: 'get',
                url: variables.site + '/regions',
            }).then(function (response) {
                if (response.status === 200) {
                    var choices = [];
                    response.data.data.forEach(function (region) {
                        choices.push({ value: region.id, label: region.name });
                    });
                    changeChoicesRegion(choices);
                    setChoicesRegionLoaded(true);
                }
            });
        }
    }, [choicesRegionLoaded]);

    // Fetch Cities
    useEffect(() => {
        if (!choicesVilleLoaded) {
            axios({
                method: 'get',
                url: variables.site + '/cities',
            }).then(function (response) {
                if (response.status === 200) {
                    var choices = [];
                    response.data.data.forEach(function (city) {
                        choices.push({ value: city.id, label: city.name, region: city.region });
                    });
                    changeChoicesVille(choices);
                    setChoicesVilleLoaded(true);
                }
            });
        }
    }, [choicesVilleLoaded]);

    // Fetch event types + artists (re-fetches when région / ville filters change; passes same geo params as /events)
    useEffect(() => {
        const gen = ++geoLookupsRequestGen.current;
        const params = buildGeoParamsForLookups(searchRegion, searchVille);
        Promise.all([
            axios({ method: 'get', url: variables.site + '/eventstypes', params }),
            axios({ method: 'get', url: variables.site + '/artists', params }),
        ])
            .then(function (responses) {
                if (gen !== geoLookupsRequestGen.current) return;
                const [etRes, arRes] = responses;
                if (etRes.status === 200) {
                    const choices = [];
                    etRes.data.data.forEach(function (eventType) {
                        choices.push({ value: eventType.id, label: eventType.name });
                    });
                    changeChoicesActivites(choices);
                }
                if (arRes.status === 200) {
                    const choices = [];
                    arRes.data.data.forEach(function (artist) {
                        choices.push({ value: artist.id, label: artist.name });
                    });
                    changeChoicesArtistes(choices);
                }
                setChoicesLookupsLoaded(true);
            })
            .catch(function () {
                if (gen !== geoLookupsRequestGen.current) return;
                changeChoicesActivites([]);
                changeChoicesArtistes([]);
                setChoicesLookupsLoaded(true);
            });
    }, [searchRegion, searchVille]);

    // Set allChoicesLoaded flag once all individual choices are loaded
    useEffect(() => {
        if (choicesRegionLoaded && choicesVilleLoaded && choicesLookupsLoaded) {
            setAllChoicesLoaded(true);
        }
    }, [choicesRegionLoaded, choicesVilleLoaded, choicesLookupsLoaded]);

    // Handle geolocation after initial setup and choices are loaded
    useEffect(() => {
        if ("geolocation" in navigator && !userLat && !userLng && allChoicesLoaded && defaultsChecked) {
            navigator.geolocation.getCurrentPosition(function (position) {
                changeUserLat(position.coords.latitude);
                changeUserLng(position.coords.longitude);
            });
        }
    }, [userLat, userLng, allChoicesLoaded, defaultsChecked, pathname, search]);

    // Trigger loadMoreResults after initial setup and choices are loaded
    useEffect(() => {
        if (!results && allChoicesLoaded && defaultsChecked) {
            loadMoreResults();
        }
    }, [results, allChoicesLoaded, defaultsChecked, keywordApplied, loadMoreResults, pathname, search]);

    const resetPage = useCallback(() => {
        changeLoadMoreLock(false);
        changeResults(false);
    }, []);

    // Drop activité / artiste chips that are not in the geo-filtered option lists
    useEffect(() => {
        if (!Array.isArray(searchActivites) || searchActivites.length === 0) return;
        if (!Array.isArray(choicesActivites)) return;
        if (choicesActivites.length === 0) {
            changeSearchActivites([]);
            resetPage();
            return;
        }
        const allowed = new Set(choicesActivites.map((c) => String(c.value)));
        const next = searchActivites.filter((a) => allowed.has(String(a.value)));
        if (next.length !== searchActivites.length) {
            changeSearchActivites(next);
            resetPage();
        }
    }, [searchActivites, choicesActivites, resetPage]);

    useEffect(() => {
        if (!Array.isArray(searchArtistes) || searchArtistes.length === 0) return;
        if (!Array.isArray(choicesArtistes)) return;
        if (choicesArtistes.length === 0) {
            changeSearchArtistes([]);
            resetPage();
            return;
        }
        const allowed = new Set(choicesArtistes.map((c) => String(c.value)));
        const next = searchArtistes.filter((a) => allowed.has(String(a.value)));
        if (next.length !== searchArtistes.length) {
            changeSearchArtistes(next);
            resetPage();
        }
    }, [searchArtistes, choicesArtistes, resetPage]);

    const submitKeywordSearch = useCallback(() => {
        const term = keywordDraft.trim();
        if (!term) return;
        setKeywordApplied((prev) => {
            const list = normalizeKeywordList(prev);
            if (list.includes(term)) return list;
            return [...list, term];
        });
        setKeywordDraft('');
        resetPage();
    }, [keywordDraft, resetPage]);

    const pickStructuredSuggestion = useCallback((s) => {
        setKeywordDraft('');
        switch (s.source) {
            case 'region':
                changeSearchRegion((prev) => mergeFilterOption(prev, { value: s.value, label: s.label }));
                break;
            case 'ville':
                changeSearchVille((prev) => mergeFilterOption(prev, { value: s.value, label: s.label, region: s.region }));
                break;
            case 'activite':
                changeSearchActivites((prev) => mergeFilterOption(prev, { value: s.value, label: s.label }));
                break;
            case 'artiste':
                changeSearchArtistes((prev) => mergeFilterOption(prev, { value: s.value, label: s.label }));
                break;
            default:
                break;
        }
        resetPage();
    }, [resetPage]);

    return (<div className="page-programmation">
        <Helmet>
            <title>Programmation - Fête nationale du Québec</title>
        </Helmet>
        <Header />
        <Container className="mt-md-14 mt-6 pb-md-18 pb-5">
            <ReturnLink href="https://fetenationale.gouv.qc.ca/" text="Retour au site principal" variant="a" />
            <h1 className="text-white mt-3 mb-6">Calendrier national des festivités</h1>
            <div className="searchForm">
                <div className="searchForm__stack">
                    <div className="searchForm__keywordBlock" ref={keywordBlockRef}>
                        <div className="searchForm__filtersClosed">
                            <KeywordSearchBar
                                value={keywordDraft}
                                onChange={setKeywordDraft}
                                onSubmitKeyword={submitKeywordSearch}
                                suggestions={keywordSuggestions}
                                onPickStructured={pickStructuredSuggestion}
                            />
                            <div className="searchForm__dateRow">
                                <div className="searchForm__dateChecks inline-inputs">
                                    <Input
                                        className="mb-0"
                                        label="23 juin"
                                        elementType="checkbox"
                                        value='date23'
                                        checked={date23}
                                        changed={(e) => {
                                            changeDate23(e.target.checked);
                                            resetPage();
                                        }}
                                    />
                                    <Input
                                        className="mb-0"
                                        label="24 juin"
                                        elementType="checkbox"
                                        value='date24'
                                        checked={date24}
                                        changed={(e) => {
                                            changeDate24(e.target.checked);
                                            resetPage();
                                        }}
                                    />
                                </div>
                                {!showMoreFilters ? (
                                    <button
                                        type="button"
                                        className="searchForm__moreFiltersBtn"
                                        onClick={() => setShowMoreFilters(true)}
                                    >
                                        <PlusIcon className="searchForm__moreFiltersIcon" aria-hidden />
                                        Plus de filtres
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    {showMoreFilters ? (
                        <div className="searchForm__advancedPanel">
                            <span className="sr-only searchForm__advancedPanelTitle">Plus de filtres</span>
                            <button
                                type="button"
                                className="searchForm__advancedPanelClose"
                                onClick={() => setShowMoreFilters(false)}
                            >
                                <Times aria-hidden />
                                <span className="searchForm__advancedPanelCloseLabel">Fermer les filtres</span>
                            </button>
                            <div className="searchForm__advancedFiltersInner">
                                <Row className="searchForm__advancedFilters mt-0">
                                    <Col lg="3" md="6" sm="12">
                                        <Input
                                            className="mt-0"
                                            label="Régions"
                                            elementType="select"
                                            value={searchRegion}
                                            changed={(e)=>{changeSearchRegion(e);resetPage();}}
                                            isMulti
                                            placeholder="Sélectionner une région"
                                            options={choicesRegion}
                                        />
                                    </Col>
                                    <Col lg="3" md="6" sm="12">
                                        <Input
                                            className="mt-0"
                                            label="Ville"
                                            elementType="select"
                                            value={searchVille}
                                            changed={(e)=>{changeSearchVille(e);resetPage();}}
                                            isMulti
                                            placeholder="Sélectionner une ville"
                                            options={filteredChoicesVille}
                                        />
                                    </Col>
                                    <Col lg="3" md="6" sm="12">
                                        <Input
                                            className="mt-0"
                                            label="Activités"
                                            elementType="select"
                                            value={searchActivites}
                                            changed={(e)=>{changeSearchActivites(e);resetPage();}}
                                            isMulti
                                            placeholder="Sélectionner une activité"
                                            options={Array.isArray(choicesActivites) ? choicesActivites : []}
                                        />
                                    </Col>
                                    <Col lg="3" md="6" sm="12">
                                        <Input
                                            className="mt-0"
                                            label="Artistes"
                                            elementType="select"
                                            value={searchArtistes}
                                            changed={(e)=>{changeSearchArtistes(e);resetPage();}}
                                            isMulti
                                            placeholder="Sélectionner un artiste"
                                            options={Array.isArray(choicesArtistes) ? choicesArtistes : []}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="searchRecap mt-3" role="group" aria-label="Filtres de recherche actifs">
                    {normalizeKeywordList(keywordApplied).map((kw) => (
                        <Badge
                            as="button"
                            type="button"
                            className="mb-1 searchRecap__filterChip"
                            pill
                            key={'keyword-' + kw}
                            onClick={() => { removeSearch(kw, 'keyword'); }}
                            aria-label={`Retirer le mot-clé ${kw}`}
                        >
                            {kw}
                            <Times aria-hidden />
                        </Badge>
                    ))}
                    {(Array.isArray(searchRegion) && searchRegion.length !== 0) && searchRegion.map(region=>(
                        (<Badge
                            as="button"
                            type="button"
                            className="mb-1 searchRecap__filterChip"
                            pill
                            key={'region'+region.value}
                            onClick={()=>{removeSearch(region.value,'region')}}
                            aria-label={`Retirer le filtre région ${region.label}`}
                        >
                            {region.label}
                            <Times aria-hidden />
                        </Badge>)
                    ))}
                    {(Array.isArray(searchVille) && searchVille.length !== 0) && searchVille.map(region=>(
                        (<Badge
                            as="button"
                            type="button"
                            className="mb-1 searchRecap__filterChip"
                            pill
                            key={'ville'+region.value}
                            onClick={()=>{removeSearch(region.value,'ville')}}
                            aria-label={`Retirer le filtre ville ${region.label}`}
                        >
                            {region.label}
                            <Times aria-hidden />
                        </Badge>)
                    ))}
                    {(Array.isArray(searchActivites) && searchActivites.length !== 0) && searchActivites.map(region=>(
                        (<Badge
                            as="button"
                            type="button"
                            className="mb-1 searchRecap__filterChip"
                            pill
                            key={'activity'+region.value}
                            onClick={()=>{removeSearch(region.value,'activites')}}
                            aria-label={`Retirer le filtre activité ${region.label}`}
                        >
                            {region.label}
                            <Times aria-hidden />
                        </Badge>)
                    ))}
                    {(Array.isArray(searchArtistes) && searchArtistes.length !== 0) && searchArtistes.map(region=>(
                        (<Badge
                            as="button"
                            type="button"
                            className="mb-1 searchRecap__filterChip"
                            pill
                            key={'artist'+region.value}
                            onClick={()=>{removeSearch(region.value,'artistes')}}
                            aria-label={`Retirer le filtre artiste ${region.label}`}
                        >
                            {region.label}
                            <Times aria-hidden />
                        </Badge>)
                    ))}
            </div>
            {(Array.isArray(results)) ? (
                <div>
                    <Row className="mt-5">
                        <Col>
                            <h5 className="text-white">{resultsNumber} résultats</h5>
                        </Col>
                    </Row>
                    <div className="Events">
                        <Row className="mt-2">
                            {(Array.isArray(results) && results.length !== 0) && results.map((result, index) => {
                                let filterQuery = '';
                                if (searchActivites && searchActivites.length > 0) {
                                    const activitesValues = searchActivites.map(item => item.value);
                                    filterQuery += '&activites=' + (activitesValues.length === 1 ? activitesValues[0] : encodeURIComponent(activitesValues.join(',')));
                                }
                                if (searchArtistes && searchArtistes.length > 0) {
                                    const artistesValues = searchArtistes.map(item => item.value);
                                    filterQuery += '&artists=' + (artistesValues.length === 1 ? artistesValues[0] : encodeURIComponent(artistesValues.join(',')));
                                }
                                normalizeKeywordList(keywordApplied).forEach((kw) => {
                                    filterQuery += '&keyword=' + encodeURIComponent(kw);
                                });
                                return (
                                    <Col lg="3" md="4" sm="6" className="mb-3" key={`${result.id}-${index}`}>
                                        <CardEvent 
                                            id={result.id}
                                            date={result.date_event}
                                            thumbnail={result.image_src ? result.image_src : null }
                                            thumbnail_credit={result.credits ? result.credits : null}
                                            categorie={result.type_event}
                                            titre={result.name}
                                            ville={result.city}
                                            location_lat={result.lat}
                                            location_lng={result.lng}
                                            userLat={userLat}
                                            userLng={userLng}
                                            filterQuery={filterQuery}
                                        />
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                    <div className="text-center mt-3">
                        {(loadMoreLock) ? (
                            <Button variant="outline-primary" className="is-loading" size="lg">Charger plus de résultats</Button>
                        ):(
                            <Button variant="outline-primary" size="lg" onClick={()=>{loadMoreResults()}}>Charger plus de résultats</Button>
                        )}
                    </div>
                </div>
            ) : (
                <div className="text-white mt-8"><h2>Chargement</h2></div>
            )}
        </Container>
        <Footer />
    </div>);
}
export default Programmation;